import { emailAccounts } from '../emailAccount'
import { describeTable } from './describeTable'

describeTable(emailAccounts, {
  description: `Sync configuration for one Microsoft 365 mailbox that the inbound-email lambda polls (the shared info@ inbox and any personal staff mailboxes). One row per mailbox; no secrets are stored here (auth goes through app credentials outside the database). Only is_active rows are synced. Handful of rows — a lookup table, not an event log. Join emails.email_account_id to see which mailbox a message came from.`,
  columns: {
    email: 'Mailbox address.',
    employeeId:
      'Staff member the mailbox belongs to; NULL for the shared company inbox.',
    provider: "Always 'microsoft'.",
    authType:
      "'client_credentials' = app-only Graph access; 'delegated' = on behalf of the user.",
    isActive: 'Only active accounts are polled.',
    inboxDeltaLink:
      'Graph delta-sync cursor for the Inbox folder; sentDeltaLink for Sent Items. Internal state, not analytics.',
    lastSyncAt:
      'Last successful poll. lastSyncError holds the last failure message.',
  },
})
